(() => {
  function init(root) {
    root.querySelectorAll('[data-hero-film]').forEach(el => {
      if (el.dataset.ready) return;
      el.dataset.ready = 'true';
      const video = el.querySelector('video'), button = el.querySelector('button');
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false, manual = null, pending = false;
      video.muted = true;
      function label(playing) {
        button.hidden = false;
        button.textContent = playing ? 'Pause video' : 'Play video';
        button.setAttribute('aria-label', playing ? 'Pause EUD V3 video' : 'Play EUD V3 video');
        button.setAttribute('aria-pressed', String(playing));
      }
      function wanted() { return visible && !document.hidden && (manual === true || (manual !== false && !reduce.matches)); }
      function update() {
        if (!wanted()) { video.pause(); label(false); return; }
        if (!video.paused || pending) return;
        pending = true;
        video.play().catch(() => label(false)).finally(() => { pending = false; });
      }
      video.addEventListener('playing', () => { if (!wanted()) video.pause(); else label(true); });
      video.addEventListener('pause', () => label(false));
      video.addEventListener('error', () => { label(false); button.textContent = 'Retry video'; });
      button.addEventListener('click', () => { manual = video.paused; if (video.error) video.load(); update(); });
      new IntersectionObserver(entries => { visible = entries[0].isIntersecting; update(); }, {threshold: 0}).observe(el);
      document.addEventListener('visibilitychange', update);
      reduce.addEventListener('change', () => { manual = null; update(); });
      label(false); update();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
